<template>
  <div
    class="flex w-full cursor-pointer gap-x-2 rounded-md bg-[#F9FAFB] p-4 transition"
    :class="{ 'border border-main-primary bg-main-primary/5': checked }"
    @click.self="$emit('checked')"
  >
    <input
      v-model="modelValue"
      :class="`rounded-full text-main-primary focus:border-transparent focus:ring-0 ${classes}`"
      :required="required"
      :readonly="readonly"
      :disabled="inputIsDisabled"
      :value="val"
      :name="radioName"
      type="radio"
      @blur="$emit('blur')"
      @change="$emit('checked')"
    >
    <div class="-mt-1 flex flex-col gap-y-1.5">
      <span class="font-medium text-primary">{{ radioText }}</span>
      <p
        v-if="checked"
        class="text-sm text-primary/50 transition"
      >
        {{ info }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BorderedRadioButtonWithInfo',

  props: {
    val: {
      type: [String, Number],
      required: true,
    },
    modelVal: {
      type: [String, Number],
      required: true,
    },
    radioName: {
      type: String,
      required: true,
    },
    classes: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    radioText: {
      type: String,
      required: true,
    },
    info: {
      type: String,
      required: true,
    },
  },

  emits: ['checked', 'blur'],

  data() {
    return {
      inputIsDisabled: this.disabled,
      modelValue: this.modelVal,
    }
  },

  computed: {
    checked() {
      return this.val.toString() === this.modelValue.toString()
    },
  },

  watch: {
    disabled(isDisabled) {
      this.inputIsDisabled = isDisabled
    },
    modelVal(newVal) {
      this.modelValue = newVal
    },
  },
}
</script>
